const { gql } = require("@apollo/client");

export const GET_WATER_SYSTEM_MONITORING_REPORT = gql`
    query GetWaterMonitoringReport($pwsId: String!) {
        getWaterMonitoringReport(pwsId: $pwsId) {
            systemId
            pwsId
            sections {
                sectionId
                sectionName
                showFacilityDetails
                showSampleStatus
                schedules {
                    scheduleId
                    initialBeginDate
                    scheduleBeginDate
                    scheduleEndDate
                    requiredSamplesPerPeriod
                    sampleType
                    frequency
                    lastSampled
                    sampleStatus
                    nextSampleDueYears
                    nextSampleDuePeriod
                    analyte {
                        name
                        code
                    }
                    analyteGroup {
                        name
                        code
                        analytes {
                            name
                            code
                        }
                    }
                    facility {
                        facilityId
                        facilityCode
                        name
                        samplePoints {
                            samplePointId
                            code
                            name
                            requiredSamplesPerPeriod
                            lastSampled
                            sampleStatus
                            nextSampleDueYears
                            nextSampleDuePeriod
                        }
                    }
                }
            }
            openComplianceSchedules {
                activities {
                    activityStatus
                    dateIdentified
                    deficiencies {
                        dateIdentified
                        facilityId
                        facilityDeficiency
                    }
                    dueDate
                    requiredActivities
                }
                activityStatus
                associatedDeficiencies {
                    dateIdentified
                    facilityId
                    facilityDeficiency
                }
                effectiveDate
                dueDate
                requiredActivities
                scheduleType
            }
        }
    }
`;

export const GET_GROUPED_SOURCE_SAMPLING_STATIONS = gql`
    query GetGroupedSourceSamplingStations($pwsId: String!) {
        getGroupedSourceSamplingStations(pwsId: $pwsId) {
            facilityCode
            facilityName
            activityStatus
            samplingStations {
                sourceFacilityId
                sourceName
            }
        }
    }
`;